export default __webpack_public_path__ + "media/Planning.02c1566b.svg";